import {
  CsvFieldByHeader,
  downloadCsv,
  recordsFromCsv,
} from "../../components/massFlow/csv";
import { emptyInterface, InterfacePayload } from "../types";

export const CSV_HEADERS = ["Exportador", "Interface", "Index"];

const CSV_EXAMPLES = [
  ["Roteador exemplo 01", "ether1", "1"],
  ["Roteador exemplo 01", "sfp-sfpplus1", "2"],
];

const FIELD_BY_HEADER: CsvFieldByHeader = {
  exportador: "exportador",
  roteador: "exportador",
  router: "exportador",
  nomedoroteador: "exportador",
  interface: "interface",
  nomedainterface: "interface",
  interfacename: "interface",
  index: "index",
  indice: "index",
  snmpindex: "index",
};

export function interfacesFromCsv(text: string): InterfacePayload[] {
  return recordsFromCsv(text, {
    fieldByHeader: FIELD_BY_HEADER,
    emptyValues: emptyInterface,
    expectedHeaders: CSV_HEADERS,
  });
}

export function downloadCsvTemplate() {
  downloadCsv("MW Soluções - Template Interfaces.csv", [
    CSV_HEADERS,
    ...CSV_EXAMPLES,
  ]);
}
